/* tslint:disable */
/* eslint-disable */
/**
 * pinnacle-backend API spec
 * Backend Service for Pinnacle Underwriting | [swagger.json](pinnacle/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { DeclarationScheduleResponseDto } from './DeclarationScheduleResponseDto';
import {
    DeclarationScheduleResponseDtoFromJSON,
    DeclarationScheduleResponseDtoFromJSONTyped,
    DeclarationScheduleResponseDtoToJSON,
    DeclarationScheduleResponseDtoToJSONTyped,
} from './DeclarationScheduleResponseDto';
import type { ReinsuredResponseDto } from './ReinsuredResponseDto';
import {
    ReinsuredResponseDtoFromJSON,
    ReinsuredResponseDtoFromJSONTyped,
    ReinsuredResponseDtoToJSON,
    ReinsuredResponseDtoToJSONTyped,
} from './ReinsuredResponseDto';
import type { LayerResponseDto } from './LayerResponseDto';
import {
    LayerResponseDtoFromJSON,
    LayerResponseDtoFromJSONTyped,
    LayerResponseDtoToJSON,
    LayerResponseDtoToJSONTyped,
} from './LayerResponseDto';
import type { UploadedFileResponseDto } from './UploadedFileResponseDto';
import {
    UploadedFileResponseDtoFromJSON,
    UploadedFileResponseDtoFromJSONTyped,
    UploadedFileResponseDtoToJSON,
    UploadedFileResponseDtoToJSONTyped,
} from './UploadedFileResponseDto';
import type { BrokerResponseDto } from './BrokerResponseDto';
import {
    BrokerResponseDtoFromJSON,
    BrokerResponseDtoFromJSONTyped,
    BrokerResponseDtoToJSON,
    BrokerResponseDtoToJSONTyped,
} from './BrokerResponseDto';
import type { BinderResponseDto } from './BinderResponseDto';
import {
    BinderResponseDtoFromJSON,
    BinderResponseDtoFromJSONTyped,
    BinderResponseDtoToJSON,
    BinderResponseDtoToJSONTyped,
} from './BinderResponseDto';
import type { SubmissionResponseDto } from './SubmissionResponseDto';
import {
    SubmissionResponseDtoFromJSON,
    SubmissionResponseDtoFromJSONTyped,
    SubmissionResponseDtoToJSON,
    SubmissionResponseDtoToJSONTyped,
} from './SubmissionResponseDto';

/**
 * 
 * @export
 * @interface ContractResponseDto
 */
export interface ContractResponseDto {
    /**
     * 
     * @type {Date}
     * @memberof ContractResponseDto
     */
    createdAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof ContractResponseDto
     */
    updatedAt: Date;
    /**
     * 
     * @type {string}
     * @memberof ContractResponseDto
     */
    contractId: string;
    /**
     * 
     * @type {string}
     * @memberof ContractResponseDto
     */
    binderId: string;
    /**
     * 
     * @type {string}
     * @memberof ContractResponseDto
     */
    submissionId: string;
    /**
     * 
     * @type {string}
     * @memberof ContractResponseDto
     */
    layerId: string;
    /**
     * 
     * @type {string}
     * @memberof ContractResponseDto
     */
    reinsuredId: string;
    /**
     * 
     * @type {string}
     * @memberof ContractResponseDto
     */
    brokerId: string;
    /**
     * 
     * @type {string}
     * @memberof ContractResponseDto
     */
    binderShareQuoted: string;
    /**
     * 
     * @type {string}
     * @memberof ContractResponseDto
     */
    binderShareSigned: string;
    /**
     * 
     * @type {string}
     * @memberof ContractResponseDto
     */
    gstRateOnPremium?: string;
    /**
     * 
     * @type {string}
     * @memberof ContractResponseDto
     */
    pinnacleReferenceNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof ContractResponseDto
     */
    contractStatus: ContractResponseDtoContractStatusEnum;
    /**
     * 
     * @type {Date}
     * @memberof ContractResponseDto
     */
    bindingDate?: Date;
    /**
     * 
     * @type {string}
     * @memberof ContractResponseDto
     */
    premiumPaymentWarranty?: string;
    /**
     * 
     * @type {string}
     * @memberof ContractResponseDto
     */
    brokerReference?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ContractResponseDto
     */
    installments?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ContractResponseDto
     */
    incidental?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof ContractResponseDto
     */
    incidentalCountry?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof ContractResponseDto
     */
    underwritingComments?: string;
    /**
     * 
     * @type {string}
     * @memberof ContractResponseDto
     */
    rateMovement: string;
    /**
     * 
     * @type {string}
     * @memberof ContractResponseDto
     */
    oldPinReferenceNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof ContractResponseDto
     */
    originalRate: string;
    /**
     * 
     * @type {string}
     * @memberof ContractResponseDto
     */
    adjustedRate?: string;
    /**
     * 
     * @type {string}
     * @memberof ContractResponseDto
     */
    notesAndEndorsements?: string;
    /**
     * 
     * @type {string}
     * @memberof ContractResponseDto
     */
    cedingCommissionRate?: string;
    /**
     * 
     * @type {string}
     * @memberof ContractResponseDto
     */
    sourceBrokerageRate?: string;
    /**
     * 
     * @type {string}
     * @memberof ContractResponseDto
     */
    ereRate?: string;
    /**
     * 
     * @type {string}
     * @memberof ContractResponseDto
     */
    withholdingTaxRate?: string;
    /**
     * 
     * @type {string}
     * @memberof ContractResponseDto
     */
    taxAndFeeAmount?: string;
    /**
     * 
     * @type {string}
     * @memberof ContractResponseDto
     */
    otherDeductions?: string;
    /**
     * 
     * @type {string}
     * @memberof ContractResponseDto
     */
    gstOnEre?: string;
    /**
     * 
     * @type {string}
     * @memberof ContractResponseDto
     */
    competitorRateOnExposure?: string;
    /**
     * 
     * @type {string}
     * @memberof ContractResponseDto
     */
    closingReason?: string;
    /**
     * 
     * @type {string}
     * @memberof ContractResponseDto
     */
    competitorRateOnLine?: string;
    /**
     * 
     * @type {BinderResponseDto}
     * @memberof ContractResponseDto
     */
    binder?: BinderResponseDto;
    /**
     * 
     * @type {SubmissionResponseDto}
     * @memberof ContractResponseDto
     */
    submission?: SubmissionResponseDto;
    /**
     * 
     * @type {LayerResponseDto}
     * @memberof ContractResponseDto
     */
    layer?: LayerResponseDto;
    /**
     * 
     * @type {ReinsuredResponseDto}
     * @memberof ContractResponseDto
     */
    reinsured?: ReinsuredResponseDto;
    /**
     * 
     * @type {BrokerResponseDto}
     * @memberof ContractResponseDto
     */
    broker?: BrokerResponseDto;
    /**
     * 
     * @type {Array<UploadedFileResponseDto>}
     * @memberof ContractResponseDto
     */
    files?: Array<UploadedFileResponseDto>;
    /**
     * 
     * @type {string}
     * @memberof ContractResponseDto
     */
    rateToDefaultCurrency?: string;
    /**
     * 
     * @type {string}
     * @memberof ContractResponseDto
     */
    aitRate?: string;
    /**
     * 
     * @type {string}
     * @memberof ContractResponseDto
     */
    gstRateOnCedingCommission?: string;
    /**
     * 
     * @type {string}
     * @memberof ContractResponseDto
     */
    gstRateOnSourceBrokerage?: string;
    /**
     * 
     * @type {string}
     * @memberof ContractResponseDto
     */
    financeComment?: string;
    /**
     * 
     * @type {number}
     * @memberof ContractResponseDto
     */
    noticeOfCancellationPeriod?: number;
    /**
     * 
     * @type {number}
     * @memberof ContractResponseDto
     */
    adjustmentCount?: number;
    /**
     * 
     * @type {string}
     * @memberof ContractResponseDto
     */
    underwriter?: string;
    /**
     * 
     * @type {string}
     * @memberof ContractResponseDto
     */
    totalTiv?: string;
    /**
     * 
     * @type {string}
     * @memberof ContractResponseDto
     */
    ntuReason?: ContractResponseDtoNtuReasonEnum;
    /**
     * 
     * @type {boolean}
     * @memberof ContractResponseDto
     */
    isDeclaration?: boolean | null;
    /**
     * 
     * @type {Array<DeclarationScheduleResponseDto>}
     * @memberof ContractResponseDto
     */
    declarationSchedules?: Array<DeclarationScheduleResponseDto>;
    /**
     * 
     * @type {boolean}
     * @memberof ContractResponseDto
     */
    stockDeclaration?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof ContractResponseDto
     */
    shareOfPremiumSigned?: string;
    /**
     * 
     * @type {string}
     * @memberof ContractResponseDto
     */
    pinnacleCommission?: string;
    /**
     * 
     * @type {string}
     * @memberof ContractResponseDto
     */
    rateAdequacy?: string;
    /**
     * 
     * @type {string}
     * @memberof ContractResponseDto
     */
    layerPremium?: string;
    /**
     * 
     * @type {string}
     * @memberof ContractResponseDto
     */
    basisOfCover: ContractResponseDtoBasisOfCoverEnum;
    /**
     * 
     * @type {boolean}
     * @memberof ContractResponseDto
     */
    isSlipUploaded: boolean;
    /**
     * 
     * @type {string}
     * @memberof ContractResponseDto
     */
    transactionType?: ContractResponseDtoTransactionTypeEnum;
    /**
     * Policy type for the contract
     * @type {string}
     * @memberof ContractResponseDto
     */
    policyType?: ContractResponseDtoPolicyTypeEnum;
}


/**
 * @export
 */
export const ContractResponseDtoContractStatusEnum = {
    Bound: 'Bound',
    NotTakenUp: 'Not Taken Up',
    Cancelled: 'Cancelled',
    Quoted: 'Quoted',
    Pending: 'Pending'
} as const;
export type ContractResponseDtoContractStatusEnum = typeof ContractResponseDtoContractStatusEnum[keyof typeof ContractResponseDtoContractStatusEnum];

/**
 * @export
 */
export const ContractResponseDtoNtuReasonEnum = {
    Price: 'NTU - Price',
    Unsuccessful: 'NTU - Unsuccessful',
    NoResponse: 'NTU - No response',
    Other: 'NTU - Other'
} as const;
export type ContractResponseDtoNtuReasonEnum = typeof ContractResponseDtoNtuReasonEnum[keyof typeof ContractResponseDtoNtuReasonEnum];

/**
 * @export
 */
export const ContractResponseDtoBasisOfCoverEnum = {
    AnyOneEvent: 'Any One Event',
    AnyOneLocation: 'Any One Location',
    InTheAggregate: 'In the Aggregate'
} as const;
export type ContractResponseDtoBasisOfCoverEnum = typeof ContractResponseDtoBasisOfCoverEnum[keyof typeof ContractResponseDtoBasisOfCoverEnum];

/**
 * @export
 */
export const ContractResponseDtoTransactionTypeEnum = {
    Renewal: 'Renewal',
    NewBusiness: 'New Business'
} as const;
export type ContractResponseDtoTransactionTypeEnum = typeof ContractResponseDtoTransactionTypeEnum[keyof typeof ContractResponseDtoTransactionTypeEnum];

/**
 * @export
 */
export const ContractResponseDtoPolicyTypeEnum = {
    Reinsurance: 'Reinsurance',
    Insurance: 'Insurance'
} as const;
export type ContractResponseDtoPolicyTypeEnum = typeof ContractResponseDtoPolicyTypeEnum[keyof typeof ContractResponseDtoPolicyTypeEnum];


/**
 * Check if a given object implements the ContractResponseDto interface.
 */
export function instanceOfContractResponseDto(value: object): value is ContractResponseDto {
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    if (!('contractId' in value) || value['contractId'] === undefined) return false;
    if (!('binderId' in value) || value['binderId'] === undefined) return false;
    if (!('submissionId' in value) || value['submissionId'] === undefined) return false;
    if (!('layerId' in value) || value['layerId'] === undefined) return false;
    if (!('reinsuredId' in value) || value['reinsuredId'] === undefined) return false;
    if (!('brokerId' in value) || value['brokerId'] === undefined) return false;
    if (!('binderShareQuoted' in value) || value['binderShareQuoted'] === undefined) return false;
    if (!('binderShareSigned' in value) || value['binderShareSigned'] === undefined) return false;
    if (!('contractStatus' in value) || value['contractStatus'] === undefined) return false;
    if (!('rateMovement' in value) || value['rateMovement'] === undefined) return false;
    if (!('originalRate' in value) || value['originalRate'] === undefined) return false;
    if (!('basisOfCover' in value) || value['basisOfCover'] === undefined) return false;
    if (!('isSlipUploaded' in value) || value['isSlipUploaded'] === undefined) return false;
    return true;
}

export function ContractResponseDtoFromJSON(json: any): ContractResponseDto {
    return ContractResponseDtoFromJSONTyped(json, false);
}

export function ContractResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ContractResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'createdAt': (new Date(json['createdAt'])),
        'updatedAt': (new Date(json['updatedAt'])),
        'contractId': json['contractId'],
        'binderId': json['binderId'],
        'submissionId': json['submissionId'],
        'layerId': json['layerId'],
        'reinsuredId': json['reinsuredId'],
        'brokerId': json['brokerId'],
        'binderShareQuoted': json['binderShareQuoted'],
        'binderShareSigned': json['binderShareSigned'],
        'gstRateOnPremium': json['gstRateOnPremium'] == null ? undefined : json['gstRateOnPremium'],
        'pinnacleReferenceNumber': json['pinnacleReferenceNumber'] == null ? undefined : json['pinnacleReferenceNumber'],
        'contractStatus': json['contractStatus'],
        'bindingDate': json['bindingDate'] == null ? undefined : (new Date(json['bindingDate'])),
        'premiumPaymentWarranty': json['premiumPaymentWarranty'] == null ? undefined : json['premiumPaymentWarranty'],
        'brokerReference': json['brokerReference'] == null ? undefined : json['brokerReference'],
        'installments': json['installments'] == null ? undefined : json['installments'],
        'incidental': json['incidental'] == null ? undefined : json['incidental'],
        'incidentalCountry': json['incidentalCountry'] == null ? undefined : json['incidentalCountry'],
        'underwritingComments': json['underwritingComments'] == null ? undefined : json['underwritingComments'],
        'rateMovement': json['rateMovement'],
        'oldPinReferenceNumber': json['oldPinReferenceNumber'] == null ? undefined : json['oldPinReferenceNumber'],
        'originalRate': json['originalRate'],
        'adjustedRate': json['adjustedRate'] == null ? undefined : json['adjustedRate'],
        'notesAndEndorsements': json['notesAndEndorsements'] == null ? undefined : json['notesAndEndorsements'],
        'cedingCommissionRate': json['cedingCommissionRate'] == null ? undefined : json['cedingCommissionRate'],
        'sourceBrokerageRate': json['sourceBrokerageRate'] == null ? undefined : json['sourceBrokerageRate'],
        'ereRate': json['ereRate'] == null ? undefined : json['ereRate'],
        'withholdingTaxRate': json['withholdingTaxRate'] == null ? undefined : json['withholdingTaxRate'],
        'taxAndFeeAmount': json['taxAndFeeAmount'] == null ? undefined : json['taxAndFeeAmount'],
        'otherDeductions': json['otherDeductions'] == null ? undefined : json['otherDeductions'],
        'gstOnEre': json['gstOnEre'] == null ? undefined : json['gstOnEre'],
        'competitorRateOnExposure': json['competitorRateOnExposure'] == null ? undefined : json['competitorRateOnExposure'],
        'closingReason': json['closingReason'] == null ? undefined : json['closingReason'],
        'competitorRateOnLine': json['competitorRateOnLine'] == null ? undefined : json['competitorRateOnLine'],
        'binder': json['binder'] == null ? undefined : BinderResponseDtoFromJSON(json['binder']),
        'submission': json['submission'] == null ? undefined : SubmissionResponseDtoFromJSON(json['submission']),
        'layer': json['layer'] == null ? undefined : LayerResponseDtoFromJSON(json['layer']),
        'reinsured': json['reinsured'] == null ? undefined : ReinsuredResponseDtoFromJSON(json['reinsured']),
        'broker': json['broker'] == null ? undefined : BrokerResponseDtoFromJSON(json['broker']),
        'files': json['files'] == null ? undefined : ((json['files'] as Array<any>).map(UploadedFileResponseDtoFromJSON)),
        'rateToDefaultCurrency': json['rateToDefaultCurrency'] == null ? undefined : json['rateToDefaultCurrency'],
        'aitRate': json['aitRate'] == null ? undefined : json['aitRate'],
        'gstRateOnCedingCommission': json['gstRateOnCedingCommission'] == null ? undefined : json['gstRateOnCedingCommission'],
        'gstRateOnSourceBrokerage': json['gstRateOnSourceBrokerage'] == null ? undefined : json['gstRateOnSourceBrokerage'],
        'financeComment': json['financeComment'] == null ? undefined : json['financeComment'],
        'noticeOfCancellationPeriod': json['noticeOfCancellationPeriod'] == null ? undefined : json['noticeOfCancellationPeriod'],
        'adjustmentCount': json['adjustmentCount'] == null ? undefined : json['adjustmentCount'],
        'underwriter': json['underwriter'] == null ? undefined : json['underwriter'],
        'totalTiv': json['totalTiv'] == null ? undefined : json['totalTiv'],
        'ntuReason': json['ntuReason'] == null ? undefined : json['ntuReason'],
        'isDeclaration': json['isDeclaration'] == null ? undefined : json['isDeclaration'],
        'declarationSchedules': json['declarationSchedules'] == null ? undefined : ((json['declarationSchedules'] as Array<any>).map(DeclarationScheduleResponseDtoFromJSON)),
        'stockDeclaration': json['stockDeclaration'] == null ? undefined : json['stockDeclaration'],
        'shareOfPremiumSigned': json['shareOfPremiumSigned'] == null ? undefined : json['shareOfPremiumSigned'],
        'pinnacleCommission': json['pinnacleCommission'] == null ? undefined : json['pinnacleCommission'],
        'rateAdequacy': json['rateAdequacy'] == null ? undefined : json['rateAdequacy'],
        'layerPremium': json['layerPremium'] == null ? undefined : json['layerPremium'],
        'basisOfCover': json['basisOfCover'],
        'isSlipUploaded': json['isSlipUploaded'],
        'transactionType': json['transactionType'] == null ? undefined : json['transactionType'],
        'policyType': json['policyType'] == null ? undefined : json['policyType'],
    };
}

export function ContractResponseDtoToJSON(json: any): ContractResponseDto {
    return ContractResponseDtoToJSONTyped(json, false);
}

export function ContractResponseDtoToJSONTyped(value?: ContractResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'createdAt': ((value['createdAt']).toISOString()),
        'updatedAt': ((value['updatedAt']).toISOString()),
        'contractId': value['contractId'],
        'binderId': value['binderId'],
        'submissionId': value['submissionId'],
        'layerId': value['layerId'],
        'reinsuredId': value['reinsuredId'],
        'brokerId': value['brokerId'],
        'binderShareQuoted': value['binderShareQuoted'],
        'binderShareSigned': value['binderShareSigned'],
        'gstRateOnPremium': value['gstRateOnPremium'],
        'pinnacleReferenceNumber': value['pinnacleReferenceNumber'],
        'contractStatus': value['contractStatus'],
        'bindingDate': value['bindingDate'] == null ? undefined : ((value['bindingDate']).toISOString()),
        'premiumPaymentWarranty': value['premiumPaymentWarranty'],
        'brokerReference': value['brokerReference'],
        'installments': value['installments'],
        'incidental': value['incidental'],
        'incidentalCountry': value['incidentalCountry'],
        'underwritingComments': value['underwritingComments'],
        'rateMovement': value['rateMovement'],
        'oldPinReferenceNumber': value['oldPinReferenceNumber'],
        'originalRate': value['originalRate'],
        'adjustedRate': value['adjustedRate'],
        'notesAndEndorsements': value['notesAndEndorsements'],
        'cedingCommissionRate': value['cedingCommissionRate'],
        'sourceBrokerageRate': value['sourceBrokerageRate'],
        'ereRate': value['ereRate'],
        'withholdingTaxRate': value['withholdingTaxRate'],
        'taxAndFeeAmount': value['taxAndFeeAmount'],
        'otherDeductions': value['otherDeductions'],
        'gstOnEre': value['gstOnEre'],
        'competitorRateOnExposure': value['competitorRateOnExposure'],
        'closingReason': value['closingReason'],
        'competitorRateOnLine': value['competitorRateOnLine'],
        'binder': BinderResponseDtoToJSON(value['binder']),
        'submission': SubmissionResponseDtoToJSON(value['submission']),
        'layer': LayerResponseDtoToJSON(value['layer']),
        'reinsured': ReinsuredResponseDtoToJSON(value['reinsured']),
        'broker': BrokerResponseDtoToJSON(value['broker']),
        'files': value['files'] == null ? undefined : ((value['files'] as Array<any>).map(UploadedFileResponseDtoToJSON)),
        'rateToDefaultCurrency': value['rateToDefaultCurrency'],
        'aitRate': value['aitRate'],
        'gstRateOnCedingCommission': value['gstRateOnCedingCommission'],
        'gstRateOnSourceBrokerage': value['gstRateOnSourceBrokerage'],
        'financeComment': value['financeComment'],
        'noticeOfCancellationPeriod': value['noticeOfCancellationPeriod'],
        'adjustmentCount': value['adjustmentCount'],
        'underwriter': value['underwriter'],
        'totalTiv': value['totalTiv'],
        'ntuReason': value['ntuReason'],
        'isDeclaration': value['isDeclaration'],
        'declarationSchedules': value['declarationSchedules'] == null ? undefined : ((value['declarationSchedules'] as Array<any>).map(DeclarationScheduleResponseDtoToJSON)),
        'stockDeclaration': value['stockDeclaration'],
        'shareOfPremiumSigned': value['shareOfPremiumSigned'],
        'pinnacleCommission': value['pinnacleCommission'],
        'rateAdequacy': value['rateAdequacy'],
        'layerPremium': value['layerPremium'],
        'basisOfCover': value['basisOfCover'],
        'isSlipUploaded': value['isSlipUploaded'],
        'transactionType': value['transactionType'],
        'policyType': value['policyType'],
    };
}

